<template>
	<div :class="wrap ? 'inline whitespace-normal' : 'inline-flex whitespace-nowrap'">
		<button v-if="expandable" class="-ml-2 mr-4 mt-2 mb-auto" @click.stop="isOpen = !isOpen">
			<BaseIcon v-if="isOpen" name="mono/triangle-down" />
			<BaseIcon v-else name="mono/triangle-right" />
		</button>
		<div :class="wrap ? 'inline' : 'inline-block'">
			<span v-if="textContent" :class="{'whitespace-pre-line block leading-6 mb-2': isOpen}" class="text-content">
				{{ textContent }}
			</span>
			<component :is="spanOrUl" :class="attributesClass" class="space-x-6">
				<component :is="spanOrLi" class="tag">{{ tagName }}</component>
				<component :is="spanOrLi" v-for="[attributeKey, attributeValue] in attributes" :key="attributeKey">
					<span class="attribute">{{ attributeKey }}</span>
					<template v-if="attributeValue">
						<span class="control-character">=</span>
						<span class="attribute-value">"{{ attributeValue }}"</span>
					</template>
				</component>
			</component>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ArgHtml',
	props: {value: Object, noInnerText: Boolean},
	data() {
		return {
			isOpen: false,
			maxTruncatedCharCount: 50,
			wrap: {
				type: Boolean,
				default: () => false,
			},
		}
	},
	computed: {
		spanOrLi() {
			return this.wrap ? 'span' : 'li'
		},
		spanOrUl() {
			return this.wrap ? 'span' : 'ul'
		},
		attributesClass() {
			if (this.wrap && !this.isOpen) return 'break-all'
			else if (this.wrap && this.Open) return 'break-all'
			else if (!this.wrap && this.isOpen) return 'inline-flex'
			else return 'flex'
		},
		tagName() {
			return this.value?.data?.tagName || ''
		},
		attributes() {
			return Object.entries(this.value?.data?.attributes || {})
		},
		tagTextContent() {
			if (this.noInnerText) return ''
			const innerText = this.value?.data?.innerText
			// can e.g. be an object if `innerText` was `undefined` for a tag without inner text like `<svg/>`
			if (typeof innerText !== 'string') return ''
			return innerText.trim()
		},
		tagTextContentLineBreakIndex() {
			return this.tagTextContent.indexOf('\n')
		},
		expandable() {
			return this.tagTextContent.length > this.maxTruncatedCharCount || this.tagTextContentLineBreakIndex > 0
		},
		textContent() {
			if (this.isOpen || !this.expandable) {
				return this.tagTextContent.length < 100 ? this.tagTextContent : `${this.tagTextContent}...`
			}
			return `${this.tagTextContent.substring(
				0,
				this.tagTextContentLineBreakIndex > 0 ? this.tagTextContentLineBreakIndex : this.maxTruncatedCharCount
			)}...`
		},
	},
}
</script>

<style scoped>
.text-content::before {
	content: '“';
	color: var(--gray-400);
}
.text-content::after {
	content: '” ';
	color: var(--gray-400);
}
.control-character {
	color: var(--gray-300);
}

.tag {
	color: var(--green-200);
}

.attribute {
	color: var(--orange-300);
}

.attribute-value {
	color: var(--red-300);
}
</style>
